import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {repoAppBuilder} from '@github-ui/repo-app-builder'
import {ArtifactsRoutePath} from './route-paths'

export function buildPullRequestsArtifactsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsArtifactsRoute', {
    path: ArtifactsRoutePath,
    queries: [],
  })
}

export const pullRequestsArtifactsRoute = buildPullRequestsArtifactsRoute(repoAppBuilder)
